type BadgeColor = "green" | "amber" | "red" | "stone" | "bark" | "army" | "navy";

interface BadgeProps {
  label: string;
  color?: BadgeColor;
  size?: "sm" | "md";
}

const colorMap: Record<BadgeColor, string> = {
  green: "badge-green",
  amber: "badge-amber",
  red: "badge-red",
  stone: "badge-stone",
  bark: "badge-bark",
  army: "badge-army",
  navy: "badge-navy",
};

export function Badge({ label, color = "stone", size = "sm" }: BadgeProps) {
  return (
    <span
      className={`
        inline-flex items-center rounded-full font-medium
        ${colorMap[color]}
        ${size === "sm" ? "px-2 py-0.5 text-2xs" : "px-2.5 py-1 text-xs"}
      `}
    >
      {label}
    </span>
  );
}
